import { Article, Category, Period, TimelineEvent, SearchParams, EngagementAction } from '../types';

const API_BASE_URL = 'https://api.exploringhistory.online/api';

class ApiService {
  private async fetchData<T>(url: string): Promise<T> {
    const response = await fetch(`${API_BASE_URL}${url}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  }

  private async postData<T>(url: string, data: any): Promise<T> {
    const response = await fetch(`${API_BASE_URL}${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  }

  // Articles
  async getArticles(params: SearchParams = {}): Promise<Article[]> {
    const queryParams = new URLSearchParams();
    
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });
    
    const queryString = queryParams.toString();
    return this.fetchData<Article[]>(`/articles${queryString ? `?${queryString}` : ''}`);
  }

  async getArticleBySlug(slug: string): Promise<Article> {
    return this.fetchData<Article>(`/articles/${slug}`);
  }

  async engageWithArticle(id: number, action: EngagementAction): Promise<{ success: boolean }> {
    return this.postData<{ success: boolean }>(`/articles/${id}/engage`, { action });
  }

  // Categories
  async getCategories(): Promise<Category[]> {
    return this.fetchData<Category[]>('/categories');
  }

  // Periods
  async getPeriods(): Promise<Period[]> {
    return this.fetchData<Period[]>('/periods');
  }

  // Timeline
  async getTimelineEvents(): Promise<TimelineEvent[]> {
    return this.fetchData<TimelineEvent[]>('/timeline');
  }
}

export default new ApiService();